export default __webpack_public_path__ + "static/media/github.0b47cdce.svg";